import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="grid text-center w-full grid-rows-3 gap-4">
      <h1>!!</h1>
      <p>متاسفانه مشکلی پیش آمده! </p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}